"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// otro modulito
const next13_utils_common_is_front_app_1 = __importDefault(require("@gerenciatd/next13.utils.common.is-front-app"));
const sendGaPageEvent = (eventType) => {
    if ((0, next13_utils_common_is_front_app_1.default)()) {
        let eventValue = 'page_printed';
        if (eventType === 'view') {
            eventValue = 'page_view';
        }
        window.gtag('event', eventValue);
    }
};
exports.default = sendGaPageEvent;
//# sourceMappingURL=index.js.map